import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  SubHeaderStyled,
  BodyStyled,
  ButtonWrapperStyled,
} from './styles/ProcessingStyled';
import { ReactComponent as SuccessIcon } from '../../../../images/plan-recurrente/success-big.svg';
import { GoogleTagManager } from '../../../../helpers';

const SuccessRecurring = ({ buttonHandler }) => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/marketplace/categorias/bolsas/plan-zero',
      pagename: 'Plan Zero - Conversión',
    });
  }, []);

  return (
    <ContainerStyled>
      <HeaderStyled>Plan Recurrente listo</HeaderStyled>
      <SubHeaderStyled>Tu plan se está activando</SubHeaderStyled>
      <SuccessIcon />
      <BodyStyled>
        <p>
          Si pierdes conexión, actualiza tu red WOM y volverás a estar conectado
          en unos segundos.
        </p>
      </BodyStyled>
      <ButtonWrapperStyled>
        <Button
          color="bubbleGum"
          width="300px"
          maxWidth="300px"
          click={buttonHandler}
        >
          VOLVER AL INICIO
        </Button>
      </ButtonWrapperStyled>
    </ContainerStyled>
  );
};

SuccessRecurring.propTypes = {
  buttonHandler: PropTypes.func.isRequired,
};

export default SuccessRecurring;
